import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "650",
  height: "89",
  viewBox: "0 0 650 89",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M0 25.9965L36.1111 33.8004C72.2222 41.6042 144.444 57.2119 216.667 46.823C288.889 36.2391 361.111 0.146322 433.333 0C505.556 0.146322 577.778 36.2391 613.889 54.6268L650 72.8195V88.4272H613.889C577.778 88.4272 505.556 88.4272 433.333 88.4272C361.111 88.4272 288.889 88.4272 216.667 88.4272C144.444 88.4272 72.2222 88.4272 36.1111 88.4272H0V25.9965Z",
      fill: "#FCFAF8"
    }, null, -1)
  ])))
}
export default { render: render }